import httpClient from './httpClient'

const NotificationApi = {
  async registerNotifictaion(data) {
    try {
      const res = await httpClient.post(`/notification`, {
        accountId: data.accountId,
        notificationCode: data.notificationCode,
        message: data.message,
        ownerProfileId: data.ownerProfileId,
        level: data.level,
        url: data.url,
        startTime: data.startTime,
        endTime: data.endTime,
      })
      return res.data
    } catch (e) {
      console.log(e)
      throw e
    }
  },

  async getNotificationsByIsRead(notificationType, pageNo, pageSize, isRead) {
    try {
      const res = await httpClient.get(
        `/notification?notification_type=${notificationType}&is_read=${isRead}&page_no=${pageNo}&page_size=${pageSize}`,
      )
      return res.data
    } catch (e) {
      console.log(e)
      throw e
    }
  },

  async getAllNotifications(notificationType, pageNo, pageSize) {
    try {
      const res = await httpClient.get(
        `/notification?notification_type=${notificationType}&page_no=${pageNo}&page_size=${pageSize}`,
      )
      return res.data
    } catch (e) {
      console.log(e)
      throw e
    }
  },

  async getUnreadNotificationCount() {
    try {
      const res = await httpClient.get(`/notification/unread`)
      return res.data
    } catch (e) {
      console.log(e)
      throw e
    }
  },

  async getNotificationSettings() {
    try {
      const res = await httpClient.get(`/notification/setting/`)
      return res.data
    } catch (e) {
      console.log(e)
      throw e
    }
  },

  async readNotification(notificationIds) {
    try {
      const res = await httpClient.post(`/notification/check`, {
        notificationIds: notificationIds,
      })
      return res.data
    } catch (e) {
      console.log(e)
      throw e
    }
  },

  async changeNotificationSetting(setting) {
    try {
      const res = await httpClient.put(`/notification/setting/`, {
        item: setting,
      })
      return res.data
    } catch (e) {
      console.log(e)
      throw e
    }
  },
}

export default NotificationApi
